import { dismissFolderSelectorButton } from 'owa-locstrings/lib/strings/dismissfolderselectorbutton.locstring.json';
import loc from 'owa-localize';
import * as React from 'react';
import { DefaultButton, PrimaryButton } from 'office-ui-fabric-react/lib/Button';

import { isAnyError } from '../selectors/errorSelectors';
import { isLoading } from '../selectors/loadingSelectors';
import { observer } from 'mobx-react-lite';

const styles = require('./AttachmentFolderSelectorBottomPart.scss');

export interface AttachmentFolderSelectorBottomPartProps {
    onPrimaryButtonClicked: () => void;
    onCancelButtonClicked: () => void;
    primaryButtonString: () => string;
}

export const AttachmentFolderSelectorBottomPart = observer(
    function AttachmentFolderSelectorBottomPart(props: AttachmentFolderSelectorBottomPartProps) {
        const { primaryButtonString, onPrimaryButtonClicked, onCancelButtonClicked } = props;
        const primaryButtonDisabled = isLoading() || isAnyError();
        return (
            <div className={styles.container}>
                <div className={styles.buttonsContainer}>
                    <PrimaryButton
                        disabled={primaryButtonDisabled}
                        className={styles.primaryButton}
                        text={primaryButtonString()}
                        onClick={onPrimaryButtonClicked}
                    />

                    <DefaultButton
                        text={loc(dismissFolderSelectorButton)}
                        onClick={onCancelButtonClicked}
                    />
                </div>
            </div>
        );
    }
);
